module.exports = __webpack_public_path__ + "static/shieldMobile-1d7fb7bcb2cffcd5ee8d12e82b26a65e.png";